<template>
  <v-app v-if="this.auth==1" id="inspire">
    <v-dialog v-model="altpwd" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Dados pessoais</span>
        </v-card-title>
        <v-form ref="form">
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <label class="label-modal">Password</label>
                  <v-text-field :color="$primary" type="password" v-model="pwd"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <label class="label-modal">Confirmar password</label>
                  <v-text-field :color="$primary" type="password" v-model="cpwd" :rules="pwdRules"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :color="$primary" class="white--text" txt @click.native="altpwd=false">Cancelar</v-btn>
            <v-btn :color="$primary" class="white--text" txt @click.native="changeData">Guardar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" v-model="drawer" fixed app>
      <v-list id="side_menu" dense>
        <template v-for="item in MENU_OPTIONS">
          <v-list-item
            v-if="$_HASPERMISSION(item.name, getSession.user.id_tipo_utilizador)"
            :key="item.text"
            :to="item.to"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <div v-if="$vuetify.breakpoint.lgAndUp" class="logo-bar">
          <img :src="require('@/assets/logo.png')" />
          <div class="animation-shap">
            <div class="shap-bg"></div>
          </div>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" :color="$primary" dark app fixed>
      <v-toolbar-title style="width: 600px" class="ml-0 pl-3">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">Hema</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text v-on:click="personalData">Bem-vindo, {{getSession.user.nome}}</v-btn>
      <v-btn v-on:click.stop="logout" icon>
        <v-icon>power_settings_new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content id="main_content">
      <v-container fluid fill-height>
        <v-row>
          <PickerInstituicao
            id="PickerInstituicao"
            v-if="$_HASPERMISSION('PickerInstituicao', getSession.user.id_tipo_utilizador)"
          />
          <router-view></router-view>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
  <Login v-else-if="this.auth==0" />
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex"

import { _TOKENLOGIN, _DECODELOGIN } from "@/store/_JWT"
import _MENU from "@/store/_MENU"

import "./style.scss"

export default {
  components: {
    PickerInstituicao: () => import("@/components/PickerInstituicao")
  },
  data: () => ({
    auth: -1,
    drawer: null,
    email: "",
    pwd: "",
    cpwd: "",
    altpwd: false,
    defaultRules: null,
    pwdRules: null
  }),
  computed: {
    ...mapGetters({
      getSession: "session/getState"
    }),
    MENU_OPTIONS() {
      return _MENU
    }
  },
  watch: {},
  created() {
    //this.OpenStore();
    this.ManageSession()

    this.$eventBus.$on("login", res => {
      if (res) {
        this.SessionStart()
      }
    })
    this.$eventBus.$on("logout", () => {
      this.logout()
    })

    this.$eventBus.$on("ChangePickerInstituicao", () => {
      this.$cookies.set("i", this.getSession.instituicao)
      this.OpenStore()
    })

    this.defaultRules = [v => !!v || this.$requiredField + ""]
    this.pwdRules = [v => v == this.pwd || "*As passwords não coincidem."]
  },
  methods: {
    changeData() {
      if (this.pwd && this.pwd == this.cpwd)
        this.$store
          .dispatch("session/update", {
            id: this.getSession.user.id_utilizador,
            password: this.pwd
          })
          .then(res => {
            if (res) {
              this.$toast.success(this.$success)
              this.altpwd = false
            } else {
              this.$toast.error(this.$error)
              this.altpwd = false
            }
          })
    },
    personalData() {
      this.email = this.getSession.user.email
      this.altpwd = true
    },

    ManageSession() {
      if (!this.$session.exists()) this.auth = 0
      else {
        _DECODELOGIN(this.$cookies.get("t")).then(res => {
          this.$store
            .dispatch("session/getData", {
              email: res
            })
            .then(() => {
              if (this.getSession.session) {
                this.SessionStart()
              } else this.auth = 0
            })
        })
      }
    },

    SessionStart() {
      this.$session.start()
      this.$cookies.config("3d")
      this.$cookies.set("t", _TOKENLOGIN(this.getSession.user.email))
      this.BaseStore()
      this.OpenStore()
    },

    async OpenStore() {
      if (this.$_ISSUPER(this.getSession.user.id_tipo_utilizador))
        this.getSession.instituicao = this.$cookies.get("i")
          ? Number(this.$cookies.get("i"))
          : this.getSession.user.instituicoes[0].id_instituicao

      this.$store.dispatch(
        "utilizador/getByInstituicao",
        this.getSession.instituicao
      )
      this.$store.dispatch(
        "brigada/getByInstituicao",
        this.getSession.instituicao
      )
      this.$store.dispatch(
        "colheita/getByInstituicao",
        this.getSession.instituicao
      )
      this.$store.dispatch(
        "galardao_pedido/getByInstituicao",
        this.getSession.instituicao
      )
      this.$store.dispatch(
        "associado/getByInstituicao",
        this.getSession.instituicao
      )
      this.$store.dispatch(
        "donativo/getByInstituicao",
        this.getSession.instituicao
      )

      this.auth = 1
    },

    async BaseStore() {
      this.$store.dispatch("dadiva/get")
      this.$store.dispatch("tipo_utilizador/get")
      this.$store.dispatch("localidade/getAllDistritos")
      this.$store.dispatch("nacionalidade/get")
      this.$store.dispatch("genero/get")
      this.$store.dispatch("gs/get")
      this.$store.dispatch("estado_civil/get")
      this.$store.dispatch("galardao/get")
    },

    logout() {
      this.$store.dispatch("session/setSessionData", null).then(() => {
        this.auth = 0
        this.$session.destroy()
      })
    }
  }
}
</script>